export const GET_BOUNTIES = `
query($query:String,$start:Int,$limit:Int){
  searchBounties(query:$query,start:$start,limit:$limit){
    id
    fullName
    company
    title
    department
    demandPrice
    created_at
    bountyType
    reason
    status
    offers {
      id
      introPerson {
        id
        firstName
      }
    }
  }
}
`;

export const MY_BOUNTIES = `
query($profileId: ID, $status: String, $start: Int, $limit: Int) {
  myBounties(
    profileId: $profileId
    status: $status
    start: $start
    limit: $limit
  ) {
    id
    bountyType
    company
    fullName
    title
    status
    department
    department
    reason
    created_at
    demandPrice
    offers {
      id
      introTime
      status
      relation
      introPerson {
        id
        firstName
        lastName
      }
      comment
    }
  }
}
  `;

export const COUNT_MY_BOUNTIES = `
query($profileId: ID, $status: String) {
  bountiesConnection(where: { profileId: $profileId, status: $status }) {
    aggregate {
      count
    }
  }
}
`;

export const COUNT_TOTAL_BOUNTIES_PRICE = `
query($status: String) {
  countTotalBountyPrice(status: $status) {
    amount
  }
}
`;

export const BOUNTIES_COUNT = `
query($profileId: ID, $status: String) {
  countTotalBounties(profileId: $profileId, status: $status) {
    count
  }
}
`;

export const BOUNTIES_OFFERS_COUNT = `
query($bountyPerson: ID) {
  offersConnection(where: { bountyPerson: $bountyPerson, status: "active" }) {
    aggregate {
      count
    }
  }
}

`